module.exports = __webpack_public_path__ + "img/矩形.94331972.png";